import React from "react";
import type { LabelProps } from "./Label.types";

export const Label: React.FC<LabelProps> = ({
  children,
  required = false,
  className = "",
  htmlFor,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`text-xs font-semibold text-white/60 ${className}`}
    >
      {children}
      {required && <span className="text-danger ml-1">*</span>}
    </label>
  );
};
